import { Upload } from 'antd';
import { forwardRef } from 'react';
import { TranslatableBox } from './boxes/TranslatableBox';

export const AppUpload = forwardRef((props, ref) => {
  return <TranslatableBox {...props} as={Upload} ref={ref} />;
});
